import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import styled from "styled-components";

export const BlockContainer = styled.div`
    background-color: ${({bgColor, theme}) => (bgColor ? bgColor : theme.colors.white)};
    padding: 1rem 0;

    padding-top: ${({paddingtop}) => (paddingtop ? paddingtop : "")};

    table {
        color: ${({color, theme}) => (color ? color : theme.colors.black)};
    }

    img {
        max-width: 100%;
        width: 100%;
        height: auto;
        ${media.lessThan(breakpoints.ipad)`
			width: 100%;
			height: auto;
		`}
    }

    iframe:not(.videoIframe) {
        ${media.lessThan(breakpoints.ipad)`
			width: 100%;
			height: auto;
			min-height: 280px;
		`}
        ${media.lessThan(breakpoints.mobile)`
			width: 100%;
			height: auto;
			min-height: 200px;
		`}
    }

    ${media.lessThan(breakpoints.ipad)`
    padding: 1rem 0
	padding-top: ${({paddingtop}) => (paddingtop ? paddingtop : "")};
  
  `}
    ${media.lessThan(breakpoints.mobile)`
    padding: 1rem 0;
	padding-top: ${({paddingtop}) => (paddingtop ? paddingtop : "")};

  `}
`;
